import { capitalize } from '../../../TextUtils.js';
import Sgs from 'sgs';
import addPlus from '../addPlus.js';
import SortEntities from '../SortEntities.js';
import FilterEntities from '../FilterEntities.js';
import LimMultFormat from '../LimMultFormat.js';
import GetPrototypes from '../GetPrototypes.js';
import ThresholdTracks from './ThresholdTracks.js';
import ItemStatList from './ItemStatList.js';

/**
 * Adds the name of the tag and the title of the content of the tag to the tag's class names,
 * so that they can be targetted in the CSS for later formatting in print.
 * @param {string} tag the tag that is being specified
 * @param {(string|Array.<string>)} content the class names to apply to the tag,
 * including the type and content, in either a string or an array of strings.
 * @returns {string} a formatted starting html tag: `<span class="limit no-actions" >`
 */
export default function namedTag (tag, content) {
    if(Array.isArray(content)){
        // console.log(content)
        content = content.map(x => x.replaceAll(' ', '-').toLowerCase());
        // console.log('replaced all ', content)
        content = content.join(' ');
    }
    else {
        content = content.replaceAll(' ', '-').toLowerCase();
    }
    if(tag.includes('class')){
        const pattern = /(?:class=["'])(.*)(?:['"])/;
        let matches = tag.match(pattern);
        let newTag = tag;
        if(matches.length > 1) {
            newTag = tag.replace(matches[0], 'class="' + matches[1] + " " + content + '"');
        }
        else {
            newTag = tag.replace(matches[0], 'class="' + content + '"');
        }
        // console.log(matches);
        return newTag;
    }
    else {
        return tag.replace('>', ' class="' + content + '" >');
    }
}